import Controller, { OnClick, OnMount } from '@philips-internal/oswald-ui-core/lib/client';
import BaseController from '../BaseController'
import { APPLICATION_ROUTES } from '../../constants/application-routes';
import ConfigurationService from '../../services/configuration-services';
import { Inject } from '@odinjs/odin';
import { ImageAPI } from '@philips-internal/oswald-ui-components';
import { LayoutData } from '../../app/types';

@Controller({ fragment: 'reset-password-request-failure-and-expired', component: 'root-layout' })
class ResetPasswordRequestFailureController extends BaseController {

  @Inject('header-image')
  imageHeader: ImageAPI;

  @OnClick({ target: ['failure-ok-button'] })
  onClickLoginButton(): void {
    this.historyService.push(APPLICATION_ROUTES.LOGIN);
  }

  @OnMount({ target: ['root-layout'] })
  onMount(): void {
    const { imageHeader } = this;
    ConfigurationService.getConfigurationData().then((layoutData: LayoutData) => {
      imageHeader.setSrc(layoutData.dsUrlLogoHeader);
    });
  }
}

export default ResetPasswordRequestFailureController;
